import { classNames } from "@ember-decorators/component";
import AvatarFlair from "discourse/components/avatar-flair";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const FlairRow = dt7948.c(class FlairRow extends SelectKitRowComponent {
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.item.url}}\n      <AvatarFlair @flairName={{this.item.name}} @flairUrl={{this.item.url}} @flairBgColor={{this.item.bgColor}} @flairColor={{this.item.color}} />\n    {{/if}}\n\n    <span>{{this.label}}</span>\n  ", {
      strictMode: true,
      scope: () => ({
        AvatarFlair
      })
    }), this);
  }
}, [classNames("flair-row")]);
export default FlairRow;